<!-- nå i kompakt modus utelates visse celler og grid-layouten er definert annerledes (se ../saksliste/saksliste.scss) -->
@if (sak().erPause) {
  <div class="tittel-linje">
    <span class="nummer" data-testid="nummer"></span>
    <span class="tittel" data-testid="tittel">{{ sak().tittel }}</span>
    <span class="ansvarlig"></span>
    <span class="handlinger">
      <button mat-icon-button (click)="gaaTilSaksdetaljer()">
        <mat-icon fontSet="ion-ios-arrow-thin-right" class="mat-icon--ionic-ikon"/>
      </button>
    </span>
  </div>
  <span class="detaljer-linje">
    <ng-container *ngTemplateOutlet="tidFragment"/>
  </span>

} @else {
  <!-- sak -->
  <div class="tittel-linje">
    <span class="nummer" data-testid="nummer">
      {{ sak().nummer }}
      @if (erFavoritt()) {
        <mat-icon fontSet="ion-ios-star" class="favoritt mat-icon--ionic-ikon" inline="true"/>
      }
    </span>
    <span class="tittel" data-testid="tittel">{{ sak().tittel }}</span>
    <span class="ansvarlig" data-testid="ansvarlig">
      <avatar [medlem]="sak().ansvarlig" [navn]="sak().sp2Ansvarlig"/>
    </span>
    <span class="handlinger">
      <button mat-icon-button (click)="gaaTilSaksdetaljer()" class="mat-medium-icon-button">
        <mat-icon fontSet="ion-ios-arrow-thin-right" class="mat-icon--ionic-ikon"/>
      </button>
    </span>
  </div>

  <div class="detaljer-linje">
    <ng-container *ngTemplateOutlet="tidFragment"/>
    <tittel-verdi class="sakstype" data-testid="sakstype" tittel="{{'Sakstype'|translate}}" [verdi]="sak().sakstype?.navn ?? '-'" stil="horisontal--en-linje"/>
    <tittel-verdi class="tema" data-testid="tema" tittel="{{'Tema'|translate}}" [verdi]=" sak().tema?.navn ?? '-'" stil="horisontal--en-linje"/>
    <span class="dokumenter"
          [matTooltip]="antallDokumenter().antallUleste > 0 ? ('Du har {antall} uleste dokumenter'|translate : {antall: antallDokumenter().antallUleste}) : 'Antall dokumenter' ">
      <tittel-verdi stil="horisontal--en-linje" [class.tom-teller]="antallDokumenter().antallTotalt == 0"
                    [class.ingen-uleste]="antallDokumenter().antallUleste == 0">
        <tittel>
          <ikon-med-teller [teller]="antallDokumenter().antallUleste" skjulTellerDersomNull="true"
                           fontSet="lederplan-ikon-dokument" class="mat-icon--lederplan-ikon"/>
        </tittel>
        <verdi>{{ antallDokumenter().antallTotalt }}</verdi>
      </tittel-verdi>
    </span>
    <span class="oppgaver"
          [matTooltip]="antallOppgaver().antallForfalt > 0 ? ('{antall} oppgaver er forfalt'|translate : {antall: antallOppgaver().antallForfalt}) : 'Antall oppgaver' ">
      <tittel-verdi stil="horisontal--en-linje" [class.tom-teller]="antallOppgaver().antallTotalt == 0">
        <tittel>
          <ikon-med-teller [teller]="antallOppgaver().antallForfalt" skjulTellerDersomNull="true"
                           fontSet="lederplan-ikon-oppgave" class="mat-icon--lederplan-ikon"/>
        </tittel>
        <verdi>{{ antallOppgaver().antallTotalt }}</verdi>
      </tittel-verdi>
    </span>
    <span class="beslutninger" matTooltip="{{'Antall beslutninger'|translate}}">
      <tittel-verdi stil="horisontal--en-linje" [class.tom-teller]="antallBeslutninger() == 0">
        <tittel>
          <mat-icon fontSet="lederplan-ikon-beslutning" class="mat-icon--lederplan-ikon" inline="true"/>
        </tittel>
        <verdi>{{ antallBeslutninger() }}</verdi>
      </tittel-verdi>
    </span>
    <span class="kommentarer" matTooltip="{{'Antall kommentarer'|translate}}">
      <tittel-verdi stil="horisontal--en-linje" [class.tom-teller]="antallKommentarer() == 0">
        <tittel>
          <mat-icon fontSet="ion-ios-chatbubble-outline" class="mat-icon--ionic-ikon" inline="true"/>
        </tittel>
        <verdi>{{ antallKommentarer() }}</verdi>
      </tittel-verdi>
    </span>
  </div>
  <div class="beskrivelse-linje">
    <tittel-verdi stil="vertikal--med-linje" tittel="{{'Saksbeskrivelse'|translate}}">
      <verdi>
        <html-formatert [innhold]="sak().beskrivelse"/>
      </verdi>
    </tittel-verdi>
  </div>
}


<ng-template #tidFragment>
  <div class="tid">
    <tittel-verdi-samling stil="horisontal--en-linje" class="startklokkeslett">
      <tittel-verdi stil="horisontal--en-linje" data-testid="start">
        <tittel>
          <mat-icon fontSet="ion-ios-clock-outline" class="mat-icon--ionic-ikon" inline="true"/>
        </tittel>
        <verdi>
          @if (sak().starttidspunkt) {
            <span class="tidspunkt">{{ sak().starttidspunkt | zoneddatetimeSomPlainTime | plaintime }}</span>
          } @else {
            -
          }
        </verdi>
      </tittel-verdi>
      <tittel-verdi stil="horisontal--en-linje" data-testid="start">
        <tittel>
          <mat-icon fontSet="ion-ios-stopwatch-outline" class="mat-icon--ionic-ikon" inline="true"/>
        </tittel>
        <verdi>
          @if (varighet()) {
            <span class="varighet">{{ varighet() | duration: 'timerMinutterKort' }}</span>
          } @else {
            -
          }
        </verdi>
      </tittel-verdi>
    </tittel-verdi-samling>
  </div>
</ng-template>
